import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class Push {
  constructor(private router: Router) {
    // this.init();
  }

  public init() {
    this.askPermission();
  }

  public askPermission() {
    if (typeof Notification !== "undefined") {
      return new Promise((resolve, reject) => {
        const permissionResult = Notification.requestPermission((result) => {
          resolve(result);
        });

        if (permissionResult) {
          permissionResult.then(resolve, reject);
        }
      }).then((permissionResult) => {
        if (permissionResult !== "granted") {
          throw new Error("We weren't granted permission.");
        }
      });
    }
  }
}
